import React from "react"
import styled from "styled-components"
import { Box } from "ui/components/atoms/_atoms"

import ToolDeleteUser from "./ToolDeleteUser"
import ToolGenerateCode from "./ToolGenerateCode"
import ToolNewsletterOfferBroadcast from "./ToolNewsletterOfferBroadcast"

const Tools = () => {
  return (
    <Wrapper>
      <Content>
        <ToolGenerateCode />
      </Content>
      <Content>
        <ToolDeleteUser />
        <ToolNewsletterOfferBroadcast />
      </Content>
    </Wrapper>
  )
}

export default Tools

const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  grid-gap: ${({ theme }) => theme.space.M};
`

const Wrapper = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${({ theme }) => theme.space.M};
`
